import store from '../store/store';

let Home = () => import('../pages/Home');
let CustomPage = () => import('../pages/CustomPage');
let ProductBatch = () => import('../pages/ProductBatch');
let ProductListing = () => import('../pages/ProductListing');
let TrackOrder = () => import('../pages/TrackOrder');
let AllCategories = () => import('../pages/AllCategories');
let AllDigitalPrinting = () => import('../pages/AllDigitalPrinting');
let AllOffsetPrinting = () => import('../pages/AllOffsetPrinting');
let AllLargeformatPrinting = () => import('../pages/AllLargeformatPrinting');
let EcoPrinting = () => import('../pages/EcoPrinting');
let AllBrands = () => import('../pages/AllBrands');
let AllOffers = () => import('../pages/AllOffers');
let OfferDetails = () => import('../pages/OfferDetails');
let AllBlogs = () => import('../pages/AllBlogs');
let BlogDetails = () => import('../pages/BlogDetails');
let Portfolios = () => import('../pages/Portfolios');
let PortfolioDetails = () => import('../pages/PortfolioDetails');
let Boards = () => import('../pages/Boards');
let BoardDetails = () => import('../pages/BoardDetails');
let CompanyLocation = () => import('../pages/company/Location');

export default [
    {
        // ShopRoutes의 /:slug(requiresAuth:true)보다 앞에 등록해 비로그인 접근 허용.
        // 정규식으로 slug를 파라미터로 캡처해야 CustomPage가 $route.params.pageSlug를 읽을 수 있음.
        path: '/:pageSlug(fsc-intro)',
        component: CustomPage,
        name: 'FscIntro',
        meta: { requiresAuth: false },
    },
    {
        path: '',
        component: Home,
        name: 'Home',
        // 로그아웃 후 "메인으로 가기" 버튼이 실제로 메인페이지를 보여주려면 이 라우트는 비로그인도
        // 접근 가능해야 함(requiresAuth=true면 인증 가드가 곧바로 로그인 화면으로 되돌려 보냄).
        // Home.vue는 비로그인 시 상품/배너 등 거래처별 카탈로그 데이터를 따로 불러오지 않으므로
        // (currentUserShopSlug 없으면 fetchShopHomeContent()가 스킵) 폐쇄몰 정책과 충돌 없음.
        meta: { requiresAuth: false },
    },
    {
        path: '/all-categories',
        component: AllCategories,
        name: 'AllCategories',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-digital-printing',
        component: AllDigitalPrinting,
        name: 'AllDigitalPrinting',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-offset-printing',
        component: AllOffsetPrinting,
        name: 'AllOffsetPrinting',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-largeformat-printing',
        component: AllLargeformatPrinting,
        name: 'AllLargeformatPrinting',
        meta: { requiresAuth: true },
    },
    {
        path: '/eco-printing',
        component: EcoPrinting,
        name: 'EcoPrinting',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-brands',
        component: AllBrands,
        name: 'AllBrands',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-offers',
        component: AllOffers,
        name: 'AllOffers',
        meta: { requiresAuth: true },
    },
    {
        path: '/offer/:offerSlug?',
        component: OfferDetails,
        name: 'OfferDetails',
        meta: { requiresAuth: true },
    },
    {
        path: '/shop',
        component: ProductListing,
        name: 'Shop',
        meta: { requiresAuth: true },
    },
    {
        path: '/category/:categorySlug?/:childCategorySlug?',
        name: 'Category',
        beforeEnter: (to, from, next) => {
            if (!store.getters['auth/isAuthenticated']) {
                return next({ name: 'NotFound', replace: true });
            }
            const slug = store.getters['auth/currentUserShopSlug'];
            const params = { slug, categorySlug: to.params.categorySlug };
            const query = to.params.childCategorySlug ? { sub: to.params.childCategorySlug } : {};
            next({ name: 'ShopCategory', params, query, replace: true });
        },
    },
    {
        path: '/brand/:brandId?',
        component: ProductListing,
        name: 'Brand',
        meta: { requiresAuth: true },
    },
    {
        path: '/search/:keyword?',
        component: ProductListing,
        name: 'Search',
        meta: { requiresAuth: true },
    },
    {
        // 옛 /product/:productSlug 링크(마케팅 페이지/카테고리 메뉴 등 하드코딩된 곳이 많아 전부 고치는 대신
        // 본인 shop slug로 자동 리다이렉트). storage/docs/26-06-24-07-02-상품URL-shop_id구조변경-Plan.md
        // requiresAuth: false — beforeEach가 :productSlug를 shop slug로 오인하지 않도록 beforeEnter에서만 처리
        path: '/product/:productSlug',
        name: 'ProductDetailsRedirect',
        meta: { requiresAuth: false },
        beforeEnter: async (to, from, next) => {
            const shopSlug = store.getters['auth/currentUserShopSlug'];
            if (shopSlug) {
                next({ name: 'ProductDetails', params: { slug: shopSlug, productSlug: to.params.productSlug }, replace: true });
                return;
            }
            // 비로그인: product/details API로 개방몰 여부 확인
            // 개방몰이면 해당 shop slug로 직접 리다이렉트, 폐쇄몰이면 로그인 페이지로 이동
            try {
                const res = await import('axios').then(m => (m.default || m).get(
                    store.state.app.apiPath + `product/details/${to.params.productSlug}`
                ));
                if (res.data?.success && res.data?.data?.shop?.slug) {
                    next({ name: 'ProductDetails', params: { slug: res.data.data.shop.slug, productSlug: to.params.productSlug }, replace: true });
                    return;
                }
            } catch (e) { /* ignore */ }
            next({ name: 'Login', query: { redirect: to.fullPath } });
        },
    },
    {
        path: '/product-batch/:slug',
        component: ProductBatch,
        name: 'ProductBatch',
        meta: { requiresAuth: true },
    },
    {
        path: '/track-order',
        component: TrackOrder,
        name: 'TrackOrder',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-blogs',
        component: AllBlogs,
        name: 'AllBlogs',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-blogs/category/:categorySlug?',
        component: AllBlogs,
        name: 'AllBlogsFilter',
        meta: { requiresAuth: true },
    },
    {
        path: '/all-blogs/search/:searchKeyword?',
        component: AllBlogs,
        name: 'SearchBlogs',
        meta: { requiresAuth: true },
    },
    {
        path: '/blog-details/:slug',
        component: BlogDetails,
        name: 'BlogDetails',
        meta: { requiresAuth: true },
    },

    {
        path: '/portfolios',
        component: Portfolios,
        name: 'Portfolios',
        meta: { requiresAuth: true },
    },
    {
        path: '/portfolios/category/:categorySlug?',
        component: Portfolios,
        name: 'PortfolioFilter',
        meta: { requiresAuth: true },
    },
    {
        path: '/portfolios/search/:searchKeyword?',
        component: Portfolios,
        name: 'SearchPortfolio',
        meta: { requiresAuth: true },
    },
    {
        path: '/portfolio-details/:slug',
        component: PortfolioDetails,
        name: 'PortfolioDetails',
        meta: { requiresAuth: true },
    },
    {
        path: '/boards',
        component: Boards,
        name: 'Boards',
        meta: { requiresAuth: true },
    },
    {
        path: '/boards/category/:categorySlug?',
        component: Boards,
        name: 'BoardFilterByCategory',
        meta: { requiresAuth: true },
    },
    {
        path: '/boards/search/:searchKeyword?',
        component: Boards,
        name: 'SearchBoard',
        meta: { requiresAuth: true },
    },
    {
        path: '/board-details/:slug',
        component: BoardDetails,
        name: 'BoardDetails',
        meta: { requiresAuth: true },
    },

    {
        path: '/company/location',
        component: CompanyLocation,
        name: 'CompanyLocation',
        meta: { requiresAuth: false },
    },
];
